export const SET_FOLLOW_TRADE_LIST = 'SET_FOLLOW_TRADE_LIST';
export const SET_FOLLOW_ROW_IS_OPEN = 'SET_FOLLOW_ROW_IS_OPEN';
export const SET_COPY_TIMER_ENDED = 'SET_COPY_TIMER_ENDED';
export const SET_ACTIVATION_SOCKET_UPDATE = 'SET_ACTIVATION_SOCKET_UPDATE';
export const SET_STATS_SOCKET_UPDATE = 'SET_STATS_SOCKET_UPDATE';
export const SET_COPY_INIT_STAT_VALUES = 'SET_COPY_INIT_STAT_VALUES';
export const SET_STOP_COPY = 'SET_STOP_COPY';

export const set_follow_trade_list = (value) => ({
    type: SET_FOLLOW_TRADE_LIST,
    payload: value
});

export const set_follow_row_is_open = (value) => ({
    type: SET_FOLLOW_ROW_IS_OPEN,
    payload: value
});

export const set_copy_timer_ended = (value) => ({
    type: SET_COPY_TIMER_ENDED,
    payload: value
});

export const set_activation_socket_update = (value) => ({
    type: SET_ACTIVATION_SOCKET_UPDATE,
    payload: value
});

export const set_stats_socket_update = (value) => ({
    type: SET_STATS_SOCKET_UPDATE,
    payload: value
});

export const set_copy_init_stat_values = (value) => ({
    type: SET_COPY_INIT_STAT_VALUES,
    payload: value
});

export const set_stop_copy = (value) => ({
    type: SET_STOP_COPY,
    payload: value
});